import { INITIAL_STATE_FORM_CONSULTA_CIERRES } from "../../../containers/hospitalizacion/utils/HospitalizacionConstants";

const exportedObject = {
  consultarIngresosPssData: {},
  consultarIngresosPssLoading: false,
  consultarIngresosPssError: null,

  consultarCoberturasCierreCuentaData: {},
  consultarCoberturasCierreCuentaLoading: false,
  consultarCoberturasCierreCuentaError: null,

  eliminarCoberturaData: {},
  eliminarCoberturaLoading: false,
  eliminarCoberturaError: null,

  buscarCuentasCerradasData: {},
  buscarCuentasCerradasLoading: false,
  buscarCuentasCerradasError: null,

  validarCoberturaData: {},
  validarCoberturaLoading: false,
  validarCoberturaError: null,

  validarServicioAmbulatorioData: {},
  validarServicioAmbulatorioLoading: false,
  validarServicioAmbulatorioError: null,

  consultarTipoPssNoMedicoData: {},
  consultarTipoPssNoMedicoLoading: false,
  consultarTipoPssNoMedicoError: null,

  validarAfiliadoVigenteData: {},
  validarAfiliadoVigenteLoading: false,
  validarAfiliadoVigenteError: null,

  guardarEgresoData: {},
  guardarEgresoLoading: false,
  guardarEgresoError: null,

  consultarReclamantesData: {},
  consultarReclamantesLoading: false,
  consultarReclamantesError: null,

  calcularOxigenoData: {},
  calcularOxigenoLoading: false,
  calcularOxigenoError: null,
  insertarCoberturaData: {},
  insertarCoberturaLoading: false,
  insertarCoberturaError: null,

  cerrarCuentaClinicaData: {},
  cerrarCuentaClinicaLoading: false,
  cerrarCuentaClinicaError: null,

  validarIngresoExistenteData: {},
  validarIngresoExistenteLoading: false,
  validarIngresoExistenteError: null,

  enviarReclamacionData: {},
  enviarReclamacionLoading: false,
  enviarReclamacionError: null,

  formConsultaCierresCuentasData: INITIAL_STATE_FORM_CONSULTA_CIERRES,
  formConsultaCierresCuentasLoading: false,
  consultarCierresCuentasLoading: false,

  consultarPlanesEgresoData: {},
  consultarPlanesEgresoLoading: false,
  consultarPlanesEgresoError: null,

  cambiarServicioData: {},
  cambiarServicioLoading: false,
  cambiarServicioError: null,

  consultarEstatusHojaQuirurgicaData: {},
  consultarEstatusHojaQuirurgicaLoading: false,
  consultarEstatusHojaQuirurgicaError: null,

  consultaIngresoDetalleCoberturaHojaQxData: {},
  consultaIngresoDetalleCoberturaHojaQxLoading: false,
  consultaIngresoDetalleCoberturaHojaQxError: null,

  consultarDiasHospitalariosData: {},
  consultarDiasHospitalariosLoading: false,
  consultarDiasHospitalariosError: null,
};

export default exportedObject;
